export function init(name) {
    const playersItems = $(name);

    if (!playersItems.length) {
        return;
    }

    playersItems.each(function(i, $elem) {
        let boxPlayers = window.boxPlayers ? window.boxPlayers : [];
        let index = boxPlayers.length;

        let currentPlayer = {
            'id': index+1,
            'player': null,
            'options': {},
            'prevVolume': 1,
            'videoType': getPlayerType($elem),
            'element': $elem
        };

        currentPlayer = initPlayers(currentPlayer);

        boxPlayers[index] = currentPlayer;
        window.boxPlayers = boxPlayers;
    });
}

export function destroy() {
    window.boxPlayers = {};
}

function getPlayerType($elem) {
    return ($($elem).data('type') === 'youtube') ? 'youtube' : 'vimeo';
}

function initPlayers(currentPlayer) {
    return currentPlayer.videoType === 'youtube' ? initYouTubePlayer(currentPlayer) : initVimeoPlayer(currentPlayer);
}

function initYouTubePlayer(currentPlayer) {
    const $elem = currentPlayer.element;

    let tag = document.createElement('script');
    tag.src = "//www.youtube.com/iframe_api?origin=" + window.location.href;
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player = $($elem);
    const body = $('body');

    currentPlayer.options = {
        ratio: 16 / 9,
        videoId: player.data('movie-id'),
        videoTag: player.data('movie-video-tag'),
        mute: false,
        repeat: true,
        width: player.width(),
        start: 0,
        autohide: 1,
        loop: 1,
    };

    window.onYouTubeIframeAPIReady = function () {
        currentPlayer.player = new YT.Player(currentPlayer.options.videoTag, {
            width: currentPlayer.options.width,
            height: Math.ceil(currentPlayer.options.width / currentPlayer.options.ratio),
            videoId: currentPlayer.options.videoId,
            playsinline: body.hasClass('is-desktop'),
            playerVars: {
                controls: 0,
                showinfo: 0,
                modestbranding: 1,
                wmode: 'transparent',
                cc_load_policy: 1,
                disablekb: 1,
                fs: 0,
                iv_load_policy: 3,
                rel: 0,
                autohide: 1,
                loop: 1,
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    };

    window.onPlayerReady = function (e) {
        if (currentPlayer.options.mute) e.target.mute();
        e.target.seekTo(currentPlayer.options.start);
        e.target.pauseVideo();
    };

    window.onPlayerStateChange = function (state) {
        if (state.data === 0 && currentPlayer.options.repeat) {
            currentPlayer.player.seekTo(options.start);
        }
    };

    player.click(function(e) {
        e.preventDefault();

        if (body.hasClass('is-desktop') || body.hasClass('android')) {
            let div = document.createElement("div");
            div.className += ' modal-movie';
            div.id = 'modal-movie';
            div.innerHTML = "<div class='close | js-close-modal'><i class='icon icon-cancel'></i></div><div id='video-elem-modal'></div>";
            document.body.appendChild(div);

            let modal = $('#modal-movie');

            let modalPlayer = new YT.Player('video-elem-modal', {
                width: $(window).width(),
                height: Math.ceil($(window).width() / currentPlayer.options.ratio),
                videoId: currentPlayer.options.videoId,
                playerVars: {
                    controls: 1,
                    showinfo: 0,
                    modestbranding: 1,
                    wmode: 'transparent',
                    cc_load_policy: 1,
                    disablekb: 1,
                    fs: 0,
                    iv_load_policy: 3,
                    rel: 0,
                    autohide: 1,
                    loop: 1,
                },
                events: {
                    'onReady': onModalPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });

            function onModalPlayerReady() {
                modalPlayer.unMute();
                modalPlayer.playVideo();
                modalPlayer.seekTo(0);
                modal.fadeIn();

                modal.find('.js-close-modal').click(function (e) {
                    e.preventDefault();

                    modalPlayer.pauseVideo();

                    modal.fadeOut(function () {
                        modal.remove();
                    });
                });
            }
        } else {
            if (currentPlayer.player) {
                currentPlayer.player.playVideo();
            }
        }
    });

    return currentPlayer;
}

function initVimeoPlayer(currentPlayer) {
    const $elem = currentPlayer.element;

    let tag = document.createElement('script');
    tag.src = "//player.vimeo.com/api/player.js?origin=" + window.location.href;

    if (tag.readyState) {
        tag.onreadystatechange = function () {
            if (tag.readyState === "loaded" || tag.readyState === "complete") {
                tag.onreadystatechange = null;
                loadPlayer();
            }
        };
    } else {
        tag.onload = function () {
            loadPlayer();
        };
    }

    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    let player = $($elem);
    const body = $('body');

    currentPlayer.options = {
        ratio: 16 / 9,
        videoId: player.data('movie-id'),
        videoTag: player.data('movie-video-tag'),
        mute: false,
        loop: true,
        width: player.width(),
        start: 0
    };

    let loadPlayer = function () {
        currentPlayer.player = new Vimeo.Player(currentPlayer.options.videoTag, {
            id: currentPlayer.options.videoId,
            width: currentPlayer.options.width,
            height: Math.ceil(currentPlayer.options.width / currentPlayer.options.ratio),
            autoplay: body.hasClass('is-desktop'),
            background: body.hasClass('is-desktop'),
            playsinline: body.hasClass('is-desktop'),
            loop: currentPlayer.options.loop
        });

        if (body.hasClass('is-desktop')) {
            currentPlayer.player.on('loaded', function () {
                currentPlayer.player.setCurrentTime(currentPlayer.options.start);
                currentPlayer.player.setVolume(0);
                currentPlayer.player.pause();
            });

            currentPlayer.firstTime = true;

            currentPlayer.player.on('play', function () {
                if (currentPlayer.firstTime) {
                    currentPlayer.player.pause();
                    currentPlayer.firstTime = false;
                }
            });
        }

        player.click(function(e) {
            e.preventDefault();

            if (body.hasClass('is-desktop') || body.hasClass('android')) {
                let div = document.createElement("div");
                div.classList = "modal-movie";
                div.id = 'modal-movie';
                div.innerHTML = "<div class='close | js-close-modal'><i class='icon icon-cancel'></i></div><div id='video-elem-modal'></div>";
                document.body.appendChild(div);

                let modal = $('#modal-movie');

                let modalPlayer = new Vimeo.Player('video-elem-modal', {
                    id: currentPlayer.options.videoId,
                    width: $(window).width(),
                    height: Math.ceil($(window).width() / currentPlayer.options.ratio),
                    autoplay: true,
                    background: false,
                    loop: currentPlayer.options.loop,
                    playsinline: body.hasClass('is-desktop'),
                });

                modalPlayer.on('loaded', function () {
                    modalPlayer.setCurrentTime(0);
                    modalPlayer.setVolume(currentPlayer.prevVolume);
                    modal.fadeIn();
                });

                modal.find('.js-close-modal').click(function (e) {
                    e.preventDefault();

                    modalPlayer.pause();

                    modal.fadeOut(function () {
                        modal.remove();
                    });
                });
            } else {
                if (currentPlayer.player) {
                    currentPlayer.player.play();
                }
            }
        });
    };

    return currentPlayer;
}
